module.exports = __webpack_public_path__ + "static/media/AndreaYapEnRuiEdited.38ac267a.jpg";